import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';

import {
  Row,
  Col,
  CardBody,
  Card,
} from "reactstrap";
import $ from 'jquery';

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader.js";
import "../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../components/Alerts/alerts.js";

import CustomerService from "./Customer.service.js";
import AuthService from "../../Authentication/auth.service.js";

import DataTable from 'react-data-table-component';
import { Tooltip } from "@mui/material";

import CustomerFilter from "../../../components/Table Filters/InvoiceFilter/CustomerFilter3.js";
import AlertService from "../../../components/Alerts/alerts.js";
import PermissionAccess from '../../../PermissionAccess/Access.js';



const CustomersList = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [pdfModalIsOpen, setPDFModalIsOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [filterInvoice_StartDate, setFilterInvoice_StartDate] = useState('');
  const [filterInvoicdue_date, setFilterInvoicdue_date] = useState('');
  const [filterDue_StartDate, setFilterDue_StartDate] = useState('');
  const [filterDudue_date, setFilterDudue_date] = useState('');
  const [search_text, setSearchText] = useState('');
  const [modal, setModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState("");
  const [filterText1, setFilterText1] = useState('');
  const [filterText2, setFilterText2] = useState('');
  const [filterText3, setFilterText3] = useState('');
  const [filterBusiness, setFilterBusiness] = useState('');
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const stored_user = authData.userData

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchCustomers(0, pageLimit);
  }, [pageLimit]);

  function setFilterTextFtn(itemrec, param) {
    //iph todo: 47
    //console.log(itemrec)
    //iph todo: 47
    //console.log('Value of key1:', itemrec);
    if (param === 'users') {
      setFilterText1(itemrec);
    }
    if (param === 'orders') {
      setFilterText2(itemrec);
    }
  };



  const toggleModal = () => {
    setModal(!modal);
  };





  function SubmitInvoices(_id) {
    var getData = {
      functionName: "SubmitSingleInvoices",
      postData: {
        invoice_id: _id
      }
    }
    // setLoading(true);
    CustomerService.SubmitSingleInvoices(getData).then((response) => {
      // setLoading(false);
      //iph todo: 47
      //console.log("Get Drivers response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        // window.location.reload();
      }
      else {
        // window.location.reload();
        AlertService.swalSuccessAlert(response.data.message);
      }
      fetchCustomers(currentPage, pageLimit)
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };

  function CancelInvoiceManually(_id) {
    Alerts.swalConfirmDeleteAlert(t("Are you sure you want to cancel this invoice in AutoCount? This action cannot be undone."))
      .then(res => {
        if (res === true) {
          setLoading(true);
          var getData = {
            functionName: "CancelInvoiceManually",
            postData: {
              invoice_id: _id
            }
          }
          
          CustomerService.CancelInvoiceManually(getData).then((response) => {
            setLoading(false);
            //iph todo: 47
            //console.log("Cancel Invoice response:-", response)
            if (response.data.message === "Unauthorized") {
              AuthService.logout();
              navigate("/login");
              window.location.reload();
            }
            else {
              if (response.data.status) {
                Alerts.swalSuccessAlert(response.data.message);
                fetchCustomers(currentPage, pageLimit);
              }
              else {
                Alerts.swalErrorAlert(response.data.message);
              }
            }
          },
            (error) => {
              setLoading(false);
              const errContent =
                (error.response && error.response.data) || error.message || error.toString();
              Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
            })
        }
      });
  };

  //for search with enter keypress
  function checkenterkey(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
  };

  function fetchCustomers(page_index, page_limit, filterText1, filterText2,
    filterInvoice_StartDate, filterInvoicdue_date,
    filterDue_StartDate, filterDudue_date, search_text) {
    var filter = {};
    //iph todo: 47
    //console.log(filterText1);
    if (filterText1) {
      //iph todo: 47
      //console.log("filterText1");
      filter["customer_id"] = filterText1
    }
    if (search_text) {
      //iph todo: 47
      //console.log("search_text");
      filter["search_text"] = search_text
    }
    let business = []
    if (filterBusiness === '') {
      if (stored_user.businesses) {
        business = stored_user.businesses
      }
    } else {
      business.push(filterBusiness);
    }


    if (filterBusiness) {
      //iph todo: 47
      //console.log("filterBusiness");
      filter["filterBusiness"] = filterBusiness
    }
    if (filterText2) {
      //iph todo: 47
      //console.log("filterText1");
      filter["status"] = filterText2
    }
    if (filterDue_StartDate) {
      //iph todo: 47
      //console.log("filterDue_StartDate");
      filter["filterDue_StartDate"] = filterDue_StartDate
    } if (filterDudue_date) {
      //iph todo: 47
      //console.log("filterDudue_date");
      filter["filterDudue_date"] = filterDudue_date
    } if (filterInvoice_StartDate) {
      //iph todo: 47
      //console.log("filterInvoice_StartDate");
      filter["filterInvoice_StartDate"] = filterInvoice_StartDate
    } if (filterInvoicdue_date) {
      filter["filterInvoicdue_date"] = filterInvoicdue_date
    }
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    setLoading(true);

    CustomerService.getAllInvoices(authData.sessionID, offset, page_limit, business, filterText1,
      filterText2, filterInvoice_StartDate, filterInvoicdue_date, filterDue_StartDate, filterDudue_date, search_text).then((response) => {
        setLoading(false);
        //iph todo: 47
        //console.log("Get Customers response:-", response)
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        }
        else {
          //iph todo: 47
          //console.log(response.data);
          setCustomers(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
        (error) => {
          setLoading(false);
          const errContent =
            (error.response && error.response.data) || error.message || error.toString();
          //iph todo: 47
          //console.log("Net:-", errContent)
          if (errContent) {
            Alerts.swalErrorAlert(errContent)
          }
          else {
            Alerts.swalErrorAlert(t("Server Error, Please try again later."))
          }
        })
  };
  function handleClear(item) {
    if (item === 'users') {
      $("#colfilter").val('');
      setFilterText1('');
      setFilterBusiness('');
      setFilterText2('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
    if (item === 'action') {
      // $("#modfilter").val('');
      $("#actfilter").val('');
      setFilterBusiness('');
      setFilterText2('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
    if (item === 'function') {
      $("#funcfilter").val('');
      setFilterText3('');
      setFilterBusiness('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
  };

  function handlePageChange(page_index) {
    //iph todo: 47
    //console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchCustomers(page_index, pageLimit);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }


  function resetFilters() {
    setResetPaginationToggle(!resetPaginationToggle);
    setFilterText1('');
    setSearchText('');
    setFilterBusiness('');
    setFilterInvoice_StartDate('');
    setFilterInvoicdue_date('');
    setFilterDue_StartDate('');
    setFilterDudue_date('');
    setFilterText2('');
    fetchCustomers(0, pageLimit);

  }

  function searchCustomers() {
    setResetPaginationToggle(!resetPaginationToggle);
    // Filter values
    const filteredText1 = filterText1 || "";
    const filteredText2 = filterText2 || "";
    const FilterInvoice_StartDate1 = filterInvoice_StartDate || "";
    const FilterInvoicdue_date2 = filterInvoicdue_date || "";
    const FilterDue_StartDate3 = filterDue_StartDate || "";
    const Search_text = search_text || "";
    const FilterDudue_date4 = filterDudue_date || "";
    //iph todo: 47
    //console.log(FilterDue_StartDate3)
    //iph todo: 47
    //console.log(FilterDudue_date4)
    fetchCustomers(0, pageLimit, filteredText1, filteredText2, FilterInvoice_StartDate1,
      FilterInvoicdue_date2, FilterDue_StartDate3, FilterDudue_date4, Search_text);
  }

  function filterBussiness() {
    setResetPaginationToggle(!resetPaginationToggle);
    // Filter values
    const filteredText1 = filterText1 || "";
    const filterBusiness = filterBusiness || "";
    const filteredText2 = filterText2 || "";
    const FilterInvoice_StartDate1 = filterInvoice_StartDate || "";
    const FilterInvoicdue_date2 = filterInvoicdue_date || "";
    const FilterDue_StartDate3 = filterDue_StartDate || "";
    const Search_text = search_text || "";
    const FilterDudue_date4 = filterDudue_date || "";
    //iph todo: 47
    //console.log(FilterDue_StartDate3)
    //iph todo: 47
    //console.log(FilterDudue_date4)
    fetchCustomers(0, pageLimit, filteredText1, filteredText2, FilterInvoice_StartDate1,
      FilterInvoicdue_date2, FilterDue_StartDate3, FilterDudue_date4, Search_text);
  }

  const handleInvoicePayments = (row) => {
    if (row.status !== 'paid') {
      row.is_admin = true;
      navigate('/add-payment', { state: { row, check: false } });
    } else {
      AlertService.swalErrorAlert("Invoice Already Paid Successfully")
    }

  }
  const AdjustCreditNotes = (row) => {
    if (row.status === 'paid') {
      row.is_admin = true;
      navigate('/Adjust_Credit_Notes', { state: { row, check: false } });
    } else {
      AlertService.swalErrorAlert("Invoice should be Paid Before Adjusting Credit Notes")
    }

  }
  function confirmDeleteCustomer(_id, order_no, status) {
    if (status === 'generated') {
      let msg = t("Once deleted, you will not be able to recover this Invoice!")
      Alerts.swalConfirmDeleteAlert(msg).then(res => {
        //iph todo: 47
        //console.log("Resp:-", res)
        if (res === true) {
          sendDelete(_id, order_no)
        }
      })
    } else {
      AlertService.swalErrorAlert("Invoice status should be Generated")
    }
  };

  function sendDelete(id, order_no) {
    setLoading(true);
    CustomerService.deleteInvoice(id, order_no).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Delete customer response:-", response)
      if (response.data.status) {
        fetchCustomers(currentPage, pageLimit)
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {

          //iph todo: 47
          //console.log(response);
          setLoading(false);
          Alerts.swalSuccessAlert(t("Invoice Deleted Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the customer at the moment."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };

  const mycolumns = [
    {
      name: "Invoice Date",
      selector: "invoice_date",
      sortable: true,
      cell: (row) => row?.invoice_date ? format(parseISO(row?.invoice_date), 'dd-MM-yyyy') : '',
    },
    {
      name: "Invoice Number",
      selector: "invoice_number",
      sortable: true,
    },
    {
      name: "Order ID",
      selector: "order_number",
      sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => navigate(`/quotation_details`, { state: { id: row.order_id } })}
        >
          {row?.order_number}
        </span >
      ),
    },
    // {
    //   name: "Order ID",
    //   width: '10%',
    //   selector: "invoice_date",
    //   sortable: true,
    //   cell: (row) => row?.rfq_id ? row?.rfq_id : '',
    // },

    {
      name: 'Customer Name',
      selector: row => `${row.user_details ? row?.user_details[localStorage.getItem('invoice_to_field')] : '' || 'N/A'})`,
      sortable: true,
      cell: row => (
        <Tooltip title={`${row.user_details ? row?.user_details[localStorage.getItem('invoice_to_field')] : '' || 'N/A'})`} arrow>
          <span>{`${row.user_details ? row?.user_details[localStorage.getItem('invoice_to_field')] : '' || 'N/A'}`}</span>
        </Tooltip>
      )
    },
    {
      name: t('Status'),
      width: '10%',
      selector: (row) => {
        return (
          <div>
            {row.status === "partial paid" ?
              <button type="button" style={{ borderColor: '#F39026', backgroundColor: '#F39026' }}
                className="btn btn-success btn-hover-shine me-3 btn" onClick={() => console.log('Partial Paid clicked')}>{row.status}
              </button>
              :
              row.status === "cancelled" ?
                <button type="button"
                  className="btn btn-danger btn-hover-shine me-3 btn" onClick={() => console.log('Cancelled clicked')}>{row.status}
                </button>
                :
                row.status === "generated" ?
                  <button type="button" style={{ borderColor: '#1BD35A', backgroundColor: '#1BD35A' }}
                    className="btn btn-c btn-hover-shine me-3 btn" onClick={() => console.log('Generated clicked')}>{row.status}
                  </button>
                  :
                  row.status === "paid" ?
                    <button type="button"
                      className="btn btn-success btn-hover-shine me-3 btn" onClick={() => console.log('Paid clicked')}>{row.status}
                    </button>
                    :
                    row.status === "unpaid" ?
                      <button type="button"
                        className="btn btn-success btn-hover-shine me-3 btn" onClick={() => console.log('Unpaid clicked')}>{row.status}
                      </button>

                      :
                      row.status === "draft" ?
                        <button type="button" style={{ borderColor: '#F39026', backgroundColor: '#F39026' }}
                          className="btn btn-success btn-hover-shine me-3 btn" onClick={() => console.log('Draft clicked')}>Draft
                        </button>
                        :
                        <button type="button"
                          className="btn btn-default btn-hover-shine me-3 btn" onClick={() => console.log('Default clicked')}>{row.status}
                        </button>
            }
          </div>
        );
      }
    },
    {
      name: "Due Date",
      selector: "due_date",
      sortable: true,
      cell: (row) => row.due_date ? format(parseISO(row.due_date), 'dd-MM-yyyy') : '',
    },

    {
      name: "Total Amount",
      sortable: true,
      selector: (row) => (
        <div >{`${row.currency ? row.currency : ''}${row?.total_amount ? parseFloat(row?.total_amount).toFixed(2) : 0}`} </div>
      )
    },
    {
      name: 'Actions',
      width: '18%',
      selector: (row) => {
        return (
          <div>
            <button className="mt-2 mb-2 me-2 btn-icon btn">
              {!super_admin ? current_module?.SendEmail === 1 &&
                <Tooltip placement="top" title="Send Email" arrow>
                  <i onClick={() => handleMail(row)} className="pe-7s-mail text-primary btn-icon-wrapper"></i>
                </Tooltip>
                :
                <Tooltip placement="top" title="Send Email" arrow>
                  <i onClick={() => handleMail(row)} className="pe-7s-mail text-primary btn-icon-wrapper"></i>
                </Tooltip>}
              {/* {!super_admin ? current_module?.MakePayment === 1 &&
                <Tooltip placement="top" title="Make Payment" arrow>
                  <i onClick={() => handleInvoicePayments(row)} className="pe-7s-credit text-primary btn-icon-wrapper"></i>
                </Tooltip>
                :
                <Tooltip placement="top" title="Make Payment" arrow>
                  <i onClick={() => handleInvoicePayments(row)} className="pe-7s-credit text-primary btn-icon-wrapper"></i>
                </Tooltip>
              } */}
              {!super_admin ? current_module?.AdjustCreditNotes === 1 &&
                row?.adjust_credit_note_status === 'pending' && (
                  <Tooltip placement="top" title="Adjust Credit Notes" arrow>
                    <i onClick={() => AdjustCreditNotes(row)} className="pe-7s-note text-primary btn-icon-wrapper"></i>
                  </Tooltip>
                )
                :
                row?.adjust_credit_note_status === 'pending' && (
                  <Tooltip placement="top" title="Adjust Credit Notes" arrow>
                    <i onClick={() => AdjustCreditNotes(row)} className="pe-7s-note text-primary btn-icon-wrapper"></i>
                  </Tooltip>
                )}
              {!super_admin ? current_module?.ViewPDF === 1 &&
                <Tooltip placement="top" title="View" arrow>
                  <i onClick={() => { navigate(`/view_invoice/${row._id}`) }} className="pe-7s-look text-primary btn-icon-wrapper"> </i>
                </Tooltip> :
                <Tooltip placement="top" title="View" arrow>
                  <i onClick={() => { navigate(`/view_invoice/${row._id}`) }} className="pe-7s-look text-primary btn-icon-wrapper"> </i>
                </Tooltip>}
              {!super_admin ? current_module?.DownloadPDF === 1 &&
                <Tooltip placement="top" title="Download PDF" arrow>
                  <i onClick={() => handlePDF(row._id)} className="pe-7s-download text-success btn-icon-wrapper text-info"> </i>
                </Tooltip> :
                <Tooltip placement="top" title="Download PDF" arrow>
                  <i onClick={() => handlePDF(row._id)} className="pe-7s-download text-success btn-icon-wrapper text-info"> </i>
                </Tooltip>}


              {!super_admin ? current_module?.SubmitInvoices === 1 &&
                row.autoCount_status === "pending" &&
                <Tooltip disabled={loading} placement="top" title="Submit Invoice" arrow>
                  <i disabled={loading} onClick={() => SubmitInvoices(row._id)} className="pe-7s-paper-plane text-success btn-icon-wrapper text-info"> </i>
                </Tooltip>
                :
                row.autoCount_status === "pending" &&
                <Tooltip placement="top" title="Submit Invoice" arrow>
                  <i disabled={loading} onClick={() => SubmitInvoices(row._id)} className="pe-7s-paper-plane text-success btn-icon-wrapper text-info"> </i>
                </Tooltip>
              }

              {/* Manual Cancel Invoice Button - Show when status is cancelled but autoCount_status is not cancelled */}
              {row.status === "cancelled" && row.autoCount_status !== "cancelled" && row.invoice_number &&
                <Tooltip disabled={loading} placement="top" title="Cancel in AutoCount" arrow>
                  <i disabled={loading} onClick={() => CancelInvoiceManually(row._id)} className="pe-7s-close-circle text-warning btn-icon-wrapper"> </i>
                </Tooltip>
              }

              {/* {!super_admin ? current_module?.DeleteData === 1 &&
                <Tooltip placement="top" title="Delete Invoice" arrow>
                  <i onClick={() => confirmDeleteCustomer(row._id, row.order_no, row.status)} className="pe-7s-trash text-danger btn-icon-wrapper"> </i>
                </Tooltip>
                :
                <Tooltip placement="top" title="Delete Invoice" arrow>
                  <i onClick={() => confirmDeleteCustomer(row._id, row.order_no, row.status)} className="pe-7s-trash text-danger btn-icon-wrapper"> </i>
                </Tooltip>
              } */}
            </button>
          </div>
        );
      }
    },
  ];
  const downloadPDF = (response) => {
    //iph todo: 47
    //console.log("PDF Data Length: ", response.data.length);
    //iph todo: 47
    //console.log("Partial PDF Data: ", response.data.slice(0, 100));
    const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(pdfBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = 'invoice.pdf'; // Set the desired file name here.
    downloadLink.style.display = 'none';

    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Clean up by removing the link and revoking the URL
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  };

  const handlePDF = (_id) => {
    var getData = {
      functionName: "Get_PDF_Invoice",
      _id: _id
    }
    setLoading(true);
    CustomerService.getInvoice_PDF(getData).then((response) => {
      //iph todo: 47
      //console.log(response);
      const pre = document.createElement('pre');
      pre.textContent = response.data;
      document.body.appendChild(pre);
      setLoading(false);
      if (response.status === 200) {

        downloadPDF(response);
      } else if (response.status === 401) {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        // Handle other error cases, if necessary
        //iph todo: 47
        //console.log("Response status: " + response.status);
        // Display an error message or perform other actions as needed.
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      })
  }
  const handlePayments = (row, method) => {
    if (row.status !== 'paid') {
      method.is_admin = true;
      navigate('/add-payment', { state: { row, check: false, method } });
    } else {
      AlertService.swalErrorAlert("Invoice Already Paid Successfully")
    }

  }
  const handleEdit = (row, check) => {
    //iph todo: 47
    //console.log(row);
    if (row.status !== 'paid' && row.status !== 'partial paid') {
      navigate('/update-invoice', {
        state: {
          state: row,
          check: check
        }
      });
    } else {
      AlertService.swalErrorAlert("Paid Invoice isn't Changeable")
    }

  }

  function handleMail(row) {
    let msg = t("Are you sure you want to send Invoice in Email?")
    Alerts.swalConfirmGeneralAlert(msg).then(res => {
      //iph todo: 47
      //console.log("Resp:-", res)
      if (res === true) {
        sendMail(row)
      }
    })
  };

  function sendMail(row) {
    setLoading(true);
    CustomerService.sendPDF_Mail(row).then((response) => {
      //iph todo: 47
      //console.log("Send mail to:-", response)
      setLoading(false);
      if (response.data.status) {
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Invoice emailed Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't send the Password."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Operation failed"))
      })
  };



  const handleViewPDF = (_id) => {
    var getData = {
      functionName: "Get_PDF_Invoice",
      _id: _id
    };
    setLoading(true);
    //iph todo: 47
    //console.log(getData);
    CustomerService.getInvoice_PDF(authData.sessionID, getData)
      .then((response) => {
        setLoading(false);
        //iph todo: 47
        //console.log(response.status);
        //iph todo: 47
        //console.log(response);
        if (response.status === 200) {
          setPdfUrl(URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' })));
          setPDFModalIsOpen(true);
        } else if (response.status === 401) {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          // Handle other error cases, if necessary
          //iph todo: 47
          //console.log("Response status: " + response.status);
          // Display an error message or perform other actions as needed.
        }
      })
      .catch((error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
  };

  const PDFViewerModal = () => {
    //iph todo: 47
    //console.log(pdfUrl);
    return (
      <div
        className={`modal fade ${pdfModalIsOpen ? "show" : ""}`}
        style={{ display: pdfModalIsOpen ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content ">
            <div className="modal-header ">
              <h5 className="modal-title">Customer's Order Invoice</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setPDFModalIsOpen(false)}
              ></button>
            </div>
            <div className="modal-body">
              <iframe title="pdfUrl" src={pdfUrl} style={{ width: "100%", height: "500px" }} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <PDFViewerModal />
      <Fragment>
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className=" bg-light-gray bg-animation ">
              <div className="d-flex  justify-content-center align-items-center">
                <Col md="12" className="mx-auto app-login-box">
                  <div className="app-page-title">
                    <div className="page-title-wrapper">
                      <div className="page-title-heading fw-bold">
                        <div className="page-title-icon">
                          <i className="pe-7s-news-paper icon-gradient bg-tempting-azure" />
                        </div>
                        <div>
                          {t("Invoice Management")}
                          <div className="page-title-subheading">
                            {t('Add, Update, Delete & View Details of Invoices.')}
                          </div>
                        </div>
                      </div>
                      <div className="page-title-actions">
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                          {t("Back")}
                        </button>
                      </div>
                    </div>
                  </div>
                  <Row>
                    <Fragment>
                      <Row>
                        <Col md="12">
                          <Card className="main-card mb-3">
                            <CardBody>
                              <LoadingOverlay tag="div" active={loading}
                                styles={{ overlay: (base) => ({ ...base }) }}
                                spinner={<DNALoader />}>

                                <CustomerFilter
                                  super_admin={super_admin}
                                  accessPages={accessPages}
                                  filterBusiness={filterBusiness}
                                  onFilterBusiness={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterBusiness(e.target.value, 'users');
                                  }}
                                  authData={authData}
                                  current_module={current_module}
                                  search_text={search_text}
                                  onSearch_text={(e) => {
                                    setSearchText(e.target.value);
                                  }}

                                  onFilterInvoice_StartDate={setFilterInvoice_StartDate}
                                  onFilterInvoicdue_date={setFilterInvoicdue_date}

                                  onFilterDue_StartDate={setFilterDue_StartDate}
                                  onFilterDudue_date={setFilterDudue_date}



                                  searchCustomers={searchCustomers}
                                  resetFilters={resetFilters}
                                  onFilter1={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterTextFtn(e.target.value, 'users');
                                  }}
                                  onFilter2={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterText2(e.target.value, 'users');
                                  }}
                                  handleKeyDown={(event) => checkenterkey(event)}
                                  filterText1={filterText1}
                                  filterText2={filterText2}
                                  filterInvoice_StartDate={filterInvoice_StartDate}
                                  filterInvoicdue_date={filterInvoicdue_date}
                                  filterDue_StartDate={filterDue_StartDate}
                                  filterDudue_date={filterDudue_date}

                                  onClear={() => handleClear('users')}
                                />

                                <DataTable
                                  data={customers}
                                  columns={mycolumns}
                                  pagination
                                  fixedHeader
                                  fixedHeaderScrollHeight="400px"
                                  paginationServer
                                  paginationTotalRows={totalRows}
                                  onChangePage={handlePageChange}
                                  onChangeRowsPerPage={handlePerRowsChange}
                                  paginationResetDefaultPage={resetPaginationToggle}
                                />
                              </LoadingOverlay>

                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </Fragment>
                  </Row>
                </Col>
              </div>
            </div>
          </div>
        </div>

      </Fragment>
    </>

  );
};

export default CustomersList;